"use client";

import React from "react";
import { Card, CardBody, Image, Button, Slider } from "@nextui-org/react";
import { HeartIcon, PauseCircleIcon, NextIcon, PreviousIcon, RepeatOneIcon, ShuffleIcon } from "./Icons";
import { Job } from "@/types/types";

interface FeaturesTableProps {
    job: Job;
}

const Summary: React.FC<FeaturesTableProps> = ({ job }) => {
    const [liked, setLiked] = React.useState(false);
    const salaireMax = 10000;
    const salaireMoyenAnnuel = parseInt(job.SalaireMoyenAnnuel.replace(/[^0-9.-]+/g, ""));
    const salaireMoyenMensuel = parseInt(job.SalaireMoyenMensuel.replace(/[^0-9.-]+/g, ""));
    return (
        <Card
            isBlurred
            className="border-none bg-background/60 dark:bg-default-100/50 bg-elevation-1"
            shadow="sm"
        >
            <CardBody>
                <div className="grid grid-cols-6 md:grid-cols-12 gap-6 md:gap-4 items-center justify-center">
                    <div className="relative col-span-6 md:col-span-4 flex items-center justify-center">
                        <Image
                            alt={job.Title}
                            className="object-cover "
                            height={200}
                            shadow="md"
                            src={job.Image.url}
                            width="200"
                        />
                    </div>

                    <div className="flex flex-col col-span-6 md:col-span-8">
                        <div className="flex justify-between items-start">
                            <div className="flex flex-col gap-0">
                                <h3 className="font-semibold text-foreground/90">Salaire Mensuel (Estimations)</h3>
                                <p className="text-small text-foreground/80">{job.SalaireMoyenMensuel}</p>
                                <h1 className="text-large font-medium mt-2">{job.Name}</h1>
                            </div>
                            <Button
                                isIconOnly
                                className="text-default-900/60 data-[hover]:bg-foreground/10 -translate-y-2 translate-x-2"
                                radius="full"
                                variant="light"
                                onPress={() => setLiked((v) => !v)}
                            >
                                <HeartIcon className={liked ? "[&>path]:stroke-transparent" : ""} fill={liked ? "currentColor" : "none"} />
                            </Button>
                        </div>

                        <div className="flex flex-col mt-3 gap-1">
                            <Slider
                                aria-label="Music progress"
                                classNames={{
                                    track: "bg-default-500/30",
                                    thumb: "w-2 h-2 after:w-2 after:h-2 after:bg-foreground",
                                }}
                                color="foreground"
                                defaultValue={parseInt(job.SalaireMoyenMensuel) * 100 / salaireMax}
                                size="sm"
                            />
                            <div className="flex justify-between">
                                <p className="text-small">{job.SalaireMoyenMensuel}</p>
                                <p className="text-small text-foreground/50">{salaireMax} €</p>
                            </div>
                        </div>
                    </div>
                </div>



                <div className="grid grid-cols-3 gap-2 items-center">
                    <div className={`p-2 rounded-lg`}>
                        <h2 className={"text-2xl font-bold mb-2 text-center"}>{job.SalaireMoyenAnnuel}</h2>
                        <p className="text-gray-700 text-center"> Salaire Annuel Estimé</p>

                    </div>
                    <div className={`p-2 rounded-lg`}>
                        <h2 className={"text-2xl font-bold mb-2 text-center"}>{Math.round(100 * salaireMoyenMensuel / salaireMoyenAnnuel)} %</h2>
                        <p className="text-gray-700 text-center"> Pourcentage du salaire net par rapport au salaire brut</p>
                    </div>
                    <div className={`p-2 rounded-lg`}>
                        <h2 className={"text-2xl font-bold mb-2 text-center"}>{job.Bonus}</h2>
                        <p className="text-gray-700 text-center"> Bonus Possibles</p>
                    </div>
                </div>



            </CardBody>
        </Card>
    );
}

export default Summary;